import { GameSettingBaseProps } from "components/common/GameSettingModal";
import SocketProtocol from "network/SocketProtocol";
import SocketService from "network/SocketService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function JorneyToHomeGameSttingBody({
  setGameSetting,
  roomParams: gameParams,
  aiCount,
}: GameSettingBaseProps) {
  const { t } = useTranslation();
  const [isAreaFour, setIsAreaFour] = useState(false);

  const buttonContainer =
    "flex justify-center items-center gap-2 p-1 w-20 rounded";

  const handleAI = (add: boolean) => {
    SocketService.getInstance().emit(
      SocketProtocol.ADD_AI_PLAYER,
      gameParams.product.id,
      gameParams.room.roomName,
      add
    );
  };

  useEffect(() => {
    setGameSetting({ city: isAreaFour });
  }, [isAreaFour, setGameSetting]);

  return (
    <div className="mt-4 flex flex-col items-center justify-center">
      <div className="flex gap-10">
        <div>{t("J2H.setting")}</div>
        <input
          className="scale-150"
          type="checkbox"
          onChange={(e) => {
            setIsAreaFour(e.target.checked);
          }}
        />
      </div>
      {/* Areas */}
      <div className="flex justify-center mt-4 gap-2">
        <div className={`${buttonContainer} bg-sky-500`}>
          <i className="fas fa-cloud" />
          <div>{t("J2H.Sky")}</div>
        </div>
        <div className={`${buttonContainer} bg-green-700`}>
          <i className="fas fa-tree" />
          <div>{t("J2H.Forest")}</div>
        </div>
        <div className={`${buttonContainer} bg-blue-700`}>
          <i className="fas fa-droplet" />
          <div>{t("J2H.River")}</div>
        </div>
        {isAreaFour && (
          <div className={`${buttonContainer} bg-stone-500`}>
            <i className="fas fa-city" />
            <div>{t("J2H.City")}</div>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 mt-8 ml-10">
        <div>{t("addAI")}</div>
        <div className="flex items-center gap-1 px-2">
          <button
            className="!w-[32px] text-white text-lg"
            onClick={() => handleAI(false)}
            disabled={aiCount <= 0}
          >
            –
          </button>
          <span className="text-white min-w-[20px] text-center">{aiCount}</span>
          <button
            className="!w-[32px] text-white text-lg"
            onClick={() => handleAI(true)}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}

export default JorneyToHomeGameSttingBody;
